"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var _LRUCache = _interopRequireDefault(require("./LRUCache"));
function noop() {}
var PointerHandler = /*#__PURE__*/function () {
  function PointerHandler(element) {
    var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    (0, _classCallCheck2["default"])(this, PointerHandler);
    this.element = element;
    this.listener = listener;
    this.cache = new _LRUCache["default"](10);
    this.element.addEventListener("pointerdown", this);
    this.element.addEventListener("touchmove", this.touchmove);
  }
  return (0, _createClass2["default"])(PointerHandler, [{
    key: "touchmove",
    value: function touchmove(e) {
      // fix auto cancel and prevent disabling onclick
      e.preventDefault();
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var event = {
        id: e.pointerId,
        type: e.type,
        x: e.clientX,
        y: e.clientY,
        isPrimary: e.isPrimary
      };
      this.cache.put(e.pointerId, event);
      switch (e.type) {
        case 'pointerdown':
          e.isPrimary && this.registerEvent();
          this.listener(e.type);
          break;
        case 'pointermove':
          this.listener(e.type);
          break;
        case 'pointerup':
          this.listener(e.type);
          this.cache["delete"](e.pointerId);
          // remove event listener if all pointer is up
          this.cache.size() === 0 && this.removeEvent();
          break;
        case 'onpointercancel':
        case 'onpointerout':
        case 'onpointerleave':
          this.removeEvent();
          this.cache.clear();
          break;
        default:
      }
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return this.cache.values();
    }
  }, {
    key: "registerEvent",
    value: function registerEvent() {
      this.element.addEventListener("pointermove", this);
      this.element.addEventListener("pointerup", this);
      this.element.addEventListener("onpointercancel", this);
      this.element.addEventListener("onpointerout", this);
      this.element.addEventListener("onpointerleave", this);
    }
  }, {
    key: "removeEvent",
    value: function removeEvent() {
      this.element.removeEventListener("pointermove", this);
      this.element.removeEventListener("pointerup", this);
      this.element.removeEventListener("onpointercancel", this);
      this.element.removeEventListener("onpointerout", this);
      this.element.removeEventListener("onpointerleave", this);
    }
  }, {
    key: "getMouseCoordinates",
    value: function getMouseCoordinates(x, y) {
      // minus offset
      var bound = this.element.getBoundingClientRect();
      var offsetX = x - bound.left;
      var offsetY = y - bound.top;
      // real size of the element to the screen stretch or compress
      var clientWidth = this.element.clientWidth;
      var clientHeight = this.element.clientHeight;

      // original size of the element in canvas this is the view port
      var width = this.element.width ? this.element.width : clientWidth;
      var height = this.element.height ? this.element.height : clientHeight;
      // normalize the mouse coordinates from 0 to 1 to get percentage
      var nX = offsetX / clientWidth;
      var nY = offsetY / clientHeight;
      // multiply to the view port size to convert percentage to real position
      var fX = nX * width;
      var fY = nY * height;
      return {
        x: fX,
        y: fY
      };
    }
  }]);
}();
var _default = exports["default"] = PointerHandler;